import { render } from "./HsCheckbox.vue?vue&type=template&id=5cdc839a&scoped=true"
import script from "./HsCheckbox.vue?vue&type=script&lang=js"
export * from "./HsCheckbox.vue?vue&type=script&lang=js"

import "./HsCheckbox.vue?vue&type=style&index=0&id=5cdc839a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cdc839a"]])

export default __exports__